<div class="inputTitle" *ngIf="!trim && label">
  <span>{{ label }}<i MatSuffix matTooltip={{tooltipName}} matTooltipPosition="right" [matTooltipHideDelay]="delay"
                      id="i1" class="flaticon-message" *ngIf="tooltipIcon"></i></span>
</div>

<div class="intellisense" tabindex="-1" *ngIf="isEditable" [class.errorBorderIntellisense]="errors?.length">
    <ng-select [class.has-errors]="errors?.length" appearance="outline" [(ngModel)]="data" [items]="options"
               [bindLabel]="displayField" [bindValue]="idField" [multiple]="multiple" [searchable]="searchable"
               [loading]="loading"
               [hideSelected]="true" [compareWith]="compareField" ngOptionHighlight [disabled]="disabled"
               [placeholder]="placeholder" [closeOnSelect]="multiple ? false : true" [clearable]="clearable">

        <div *ngIf="customOptions">
            <ng-template ng-label-tmp let-item="item">
                {{ item.code }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                <div fxLayout="column" class="m-t-8 m-b-8">
                    <span class="country-code">{{ item.code }}</span>
                    <span class="hsn-code">{{ "Tax Rate: " + item.max_tax_rate + "%" }}</span>
                </div>
            </ng-template>
        </div>

        <!--Input item template-->
        <ng-template ng-label-tmp let-item="item" *ngIf="defaultChip">
            <div fxFlex="100" fxLayout="column" class="managerListShow"
                 *ngIf="labelItemTemplate == null; else labelTemplate">
                {{ displayItem(item) }}
            </div>

            <ng-template #labelTemplate>
                <ng-template [ngTemplateOutlet]="labelItemTemplate" [ngTemplateOutletContext]="{ $implicit: item }">
                </ng-template>
            </ng-template>

        </ng-template>


        <!--Dropdown item template-->

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <div fxFlex="100" fxLayout="column" class="managerListShow"
                 *ngIf="itemTemplate == null; else optionTemplate"
                 [ngClass]="{ 'disabled-option':  showSelectAll ? isItemSelected(item) : '' }">
                {{ displayItem(item) }}
            </div>

            <ng-template #optionTemplate>
                <ng-container [ngTemplateOutlet]="itemTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: index, idx:index }">
                </ng-container>
            </ng-template>

        </ng-template>
    </ng-select>
</div>

<div class="viewLable" *ngIf="!isEditable">
    <span>{{ getDisplay() }}</span>
</div>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{ item }}</li>
</ul>
